export const EMOJI_CATEGORIES = [
  {
    name: 'Phổ biến',
    icon: '🔥',
    list: ['❤️', '🔥', '😍', '👏', '😂', '👍', '🥰', '🎉', '💯', '✨', '⭐', '📚', '📖', '💡', '👑', '🙌']
  },
  {
    name: 'Cảm xúc',
    icon: '😀',
    list: ['😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂', '🙂', '😉', '😊', '😇', '🥰', '😍', '🤩', '😘', '😗', '😋', '😜', '🤪', '😝', '🤑', '🤗', '🤭', '🤫', '🤔', '🤐', '🤨', '😐', '😏', '😒', '🙄', '😬', '😮‍💨', '😌', '😔', '😪', '🤤', '😴', '😷', '🤒', '🤢', '🤮', '🥵', '🥶', '🥴', '😵', '🤯', '🤠', '🥳', '😎', '🤓', '🧐']
  },
  {
    name: 'Đọc sách',
    icon: '📖',
    list: ['📚', '📖', '📕', '📗', '📘', '📙', '📓', '📑', '📜', '📄', '🖊️', '🖋️', '📝', '💡', '🎓', '🏫', '🧠', '☕']
  },
  {
    name: 'Đánh giá & Tim',
    icon: '⭐',
    list: ['⭐', '🌟', '✨', '🔥', '💯', '🎉', '🏆', '🥇', '👑', '💖', '👍', '👎', '🙌', '🤝', '💪', '🙏', '👀', '💬', '🚀', '🍿']
  }
];

export const FUNNY_STICKERS = [
  // === Working originals ===
  { id: 'cat_vibe', code: 'Mèo gật gù', name: 'Mèo gật gù', badge: 'GIF', url: 'https://media.giphy.com/media/GeimqsH0TLDt4tScGw/giphy.gif' },
  { id: 'popcorn', code: 'Hóng biến', name: 'Hóng biến (Ăn bắp)', badge: 'GIF', url: 'https://media.giphy.com/media/NipFetnQOuKhW/giphy.gif' },
  { id: 'mindblown', code: 'Nổ não', name: 'Nổ não (Mind Blown)', badge: 'GIF', url: 'https://media.giphy.com/media/26ufdipQqU2lhNA4g/giphy.gif' },
  { id: 'gigachad', code: 'GigaChad', name: 'GigaChad 10/10', badge: 'GIF', url: 'https://media.giphy.com/media/CAYVZA5NRb529kKQUc/giphy.gif' },
  { id: 'crying', code: 'Mèo khóc', name: 'Mèo khóc dòng sông', badge: 'GIF', url: 'https://media.giphy.com/media/L95W4wv8nnb9K/giphy.gif' },
  { id: 'party', code: 'Quẩy mừng', name: 'Quẩy ăn mừng', badge: 'GIF', url: 'https://media.giphy.com/media/g9582DNuQppxC/giphy.gif' },
  { id: 'typing_cat', code: 'Mèo gõ phím', name: 'Mèo gõ phím thần tốc', badge: 'GIF', url: 'https://media.giphy.com/media/JIX9t2j0ZTN9S/giphy.gif' },
  { id: 'homer_bush', code: 'Tụt bụi cây', name: 'Tụt vào bụi cây', badge: 'GIF', url: 'https://media.giphy.com/media/COYGe9rZvfiaQ/giphy.gif' },
  { id: 'minion_cheer', code: 'Minion vỗ tay', name: 'Minion vỗ tay', badge: 'GIF', url: 'https://media.giphy.com/media/11sBLVxNs7v6WA/giphy.gif' },
  { id: 'confused_travolta', code: 'Ngơ ngác', name: 'Ngơ ngác tìm quanh', badge: 'GIF', url: 'https://media.giphy.com/media/g01ZnwAUvutuK8GIQn/giphy.gif' },
  { id: 'dramatic_chipmunk', code: 'Sóc dóc quay đầu', name: 'Sóc quay đầu cực ngầu', badge: 'GIF', url: 'https://media.giphy.com/media/aWPGuTlDqq2yc/giphy.gif' },
  { id: 'loading_brain', code: 'Não xoay tít', name: 'Não xoay loading', badge: 'GIF', url: 'https://media.giphy.com/media/DHqth0hVQoIzS/giphy.gif' },
  { id: 'disaster_girl', code: 'Cười nguy hiểm', name: 'Em bé nhà cháy', badge: 'GIF', url: 'https://media.giphy.com/media/iH7kfwoxKsmgTHvNTg/giphy.gif' },
  { id: 'thumbs_up_kid', code: 'Like chưởng', name: 'Cậu bé like giơ tay', badge: 'GIF', url: 'https://media.giphy.com/media/111ebonMs90YLu/giphy.gif' },
  { id: 'tom_reading', code: 'Tom đọc báo', name: 'Tom giật mình đọc báo', badge: 'GIF', url: 'https://media.giphy.com/media/3oKIPnAiaMCws8nOsE/giphy.gif' },
  { id: 'this_is_fine', code: 'This is fine', name: 'Chó ngồi trong lửa', badge: 'GIF', url: 'https://media.giphy.com/media/9M5jK4GXmD5o1irGrF/giphy.gif' },
  { id: 'roll_eyes_girl', code: 'Đảo mắt khinh', name: 'Đảo mắt khinh bỉ', badge: 'GIF', url: 'https://media.giphy.com/media/F3G8ymQkOkbII/giphy.gif' },
  { id: 'squidward_dance', code: 'Squidward múa', name: 'Squidward uốn dẻo múa', badge: 'GIF', url: 'https://media.giphy.com/media/hLx1RYpEamdj2/giphy.gif' },

  // === New additions ===
  { id: 'drake_approve', code: 'Drake OK', name: 'Drake gật đầu tán thành', badge: 'GIF', url: 'https://media.giphy.com/media/xT4uQulxzV39haRFjG/giphy.gif' },
  { id: 'drake_dislike', code: 'Drake từ chối', name: 'Drake lắc đầu từ chối', badge: 'GIF', url: 'https://media.giphy.com/media/3og0IPxMM0erATueVW/giphy.gif' },
  { id: 'confused_fly', code: 'Bay ngơ ngác', name: 'Bay ngơ ngác không biết gì', badge: 'GIF', url: 'https://media.giphy.com/media/YsTs5ltWtEhnq/giphy.gif' },
  { id: 'excited_dance', code: 'Nhảy sung sướng', name: 'Nhảy sung sướng tột độ', badge: 'GIF', url: 'https://media.giphy.com/media/fDzM81OYrNjJC/giphy.gif' },
  { id: 'spongebob_read', code: 'Spongebob đọc', name: 'Spongebob đọc sách tập trung', badge: 'GIF', url: 'https://media.giphy.com/media/13ZHjidRzoi7n2/giphy.gif' },
  { id: 'leo_cheers_new', code: 'Leo nâng ly', name: 'DiCaprio nâng ly ăn mừng', badge: 'GIF', url: 'https://media.giphy.com/media/UVRSXu4L4s76yze4q3/giphy.gif' },
  { id: 'no_way', code: 'Không thể tin', name: 'Không thể tin nổi luôn', badge: 'GIF', url: 'https://media.giphy.com/media/j0ShUHN7Jpi1ADyyAZ/giphy.gif' },
  { id: 'cat_huh', code: 'Mèo hả', name: 'Mèo hả ngơ ngác', badge: 'GIF', url: 'https://media.giphy.com/media/U6WxwPyG43QGs/giphy.gif' },
  { id: 'shocked_reaction', code: 'Sốc nặng', name: 'Sốc nặng không nói nên lời', badge: 'GIF', url: 'https://media.giphy.com/media/F4d8tSHcRNCTe/giphy.gif' },
  { id: 'sad_cry', code: 'Khóc nức nở', name: 'Khóc nức nở đau lòng', badge: 'GIF', url: 'https://media.giphy.com/media/vNBNypcpAaZjy/giphy.gif' },
  { id: 'what_bleach', code: 'Cái gì?', name: 'Cái gì thế này?', badge: 'GIF', url: 'https://media.giphy.com/media/StFlcHVnuz6Yy6mxcq/giphy.gif' },
  { id: 'yes_approve', code: 'Chuẩn luôn', name: 'Chuẩn luôn đồng ý', badge: 'GIF', url: 'https://media.giphy.com/media/S8LWP0CotPAQw/giphy.gif' },
  { id: 'win_moment', code: 'Thắng rồi', name: 'Chiến thắng vẫy cờ', badge: 'GIF', url: 'https://media.giphy.com/media/xNBcChLQt7s9a/giphy.gif' },
  { id: 'butterflies', code: 'Tim đập', name: 'Tim đập rộn ràng', badge: 'GIF', url: 'https://media.giphy.com/media/ZOStzpF9H5syI/giphy.gif' },
  { id: 'seriously', code: 'Nghiêm túc', name: 'Nhìn nghiêm túc đầy ẩn ý', badge: 'GIF', url: 'https://media.giphy.com/media/K6nRWiq2ViSZy/giphy.gif' },
  { id: 'laugh_hehe', code: 'Cười hê hê', name: 'Cười hê hê đểu giả', badge: 'GIF', url: 'https://media.giphy.com/media/Tq2tPTrQANKfK/giphy.gif' },
  { id: 'excited_reaction', code: 'Phấn khích', name: 'Phấn khích tột cùng', badge: 'GIF', url: 'https://media.giphy.com/media/26DN5pBQzhqgAufPq/giphy.gif' },
  { id: 'superman_go', code: 'Siêu nhân', name: 'Siêu nhân bay đi cứu thế giới', badge: 'GIF', url: 'https://media.giphy.com/media/11CPvPzgluI9Lq/giphy.gif' },
  { id: 'proud', code: 'Tự hào', name: 'Tự hào vỗ ngực', badge: 'GIF', url: 'https://media.giphy.com/media/oCXNel2GbZB7O/giphy.gif' },
  { id: 'omg_wow', code: 'Ôi trời', name: 'Ôi trời ơi không thể tin', badge: 'GIF', url: 'https://media.giphy.com/media/5TC1o3oRE68Mg/giphy.gif' },
  { id: 'confused_question', code: 'Hả???', name: 'Hả??? Giải thích đi', badge: 'GIF', url: 'https://media.giphy.com/media/7SIdExk63rTPXhbbbt/giphy.gif' },
  { id: 'cheers_toast', code: 'Cạn ly', name: 'Cạn ly chúc mừng', badge: 'GIF', url: 'https://media.giphy.com/media/t9ctG5MZhyyU8/giphy.gif' }
];

export function getStickerThemeClass(input) {
  const text = String(input || '');
  if (text.includes('🐸')) return 'sticker-theme-frog';
  if (text.includes('🤡')) return 'sticker-theme-clown';
  if (text.includes('🤯')) return 'sticker-theme-mindblown';
  if (text.includes('🗿')) return 'sticker-theme-chad';
  if (text.includes('🍿')) return 'sticker-theme-popcorn';
  if (text.includes('☕')) return 'sticker-theme-chill';
  if (text.includes('🚀')) return 'sticker-theme-peak';
  if (text.includes('🦉')) return 'sticker-theme-owl';
  if (text.includes('🥑')) return 'sticker-theme-avocado';
  if (text.includes('😭')) return 'sticker-theme-emotional';
  if (text.includes('🔥')) return 'sticker-theme-fire';
  if (text.includes('💤')) return 'sticker-theme-sleepy';
  return 'sticker-theme-default';
}

export function extractStickersAndText(str, stickerList = FUNNY_STICKERS) {
  if (!str) return { stickers: [], cleanText: '' };

  let safeStr = String(str);
  const stickers = [];

  const animatedStickerRegex = /\[sticker:([^\]]+)\]/g;
  safeStr = safeStr.replace(animatedStickerRegex, (match, val) => {
    const cleanVal = val.trim();
    let foundObj = null;

    if (cleanVal.startsWith('http://') || cleanVal.startsWith('https://')) {
      foundObj = stickerList.find(s => s.url === cleanVal) || { name: 'Sticker', url: cleanVal };
    } else {
      foundObj = stickerList.find(s => s.name === cleanVal || s.code === cleanVal || s.id === cleanVal) || { name: cleanVal, code: cleanVal };
    }

    if (foundObj) {
      stickers.push(foundObj);
    }
    return '';
  });

  return {
    stickers,
    cleanText: safeStr.trim()
  };
}

export function parseStickerContent(str, stickerList = FUNNY_STICKERS) {
  if (!str) return '';
  let safeStr = String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

  safeStr = safeStr.replace(/\n/g, '<br>');

  let extractedStickers = '';
  const animatedStickerRegex = /\[sticker:([^\]]+)\]/g;
  safeStr = safeStr.replace(animatedStickerRegex, (match, val) => {
    const cleanVal = val.trim();
    let targetUrl = '';
    let altText = cleanVal;

    if (cleanVal.startsWith('http://') || cleanVal.startsWith('https://')) {
      targetUrl = cleanVal;
      const foundByUrl = stickerList.find(s => s.url === cleanVal);
      if (foundByUrl) altText = foundByUrl.name;
      else altText = 'Sticker';
    } else {
      const found = stickerList.find(s => s.name === cleanVal || s.code === cleanVal || s.id === cleanVal);
      if (found) {
        targetUrl = found.url;
        altText = found.name;
      }
    }

    if (targetUrl) {
      extractedStickers += `<img src="${targetUrl}" alt="${altText}" title="${altText}" style="height: 100px; width: auto; display: inline-block; margin-right: 8px; margin-bottom: 8px; border-radius: 8px;" />`;
    } else {
      extractedStickers += `<span class="inline-sticker-badge sticker-theme-default" style="margin-right: 8px; margin-bottom: 8px;">${cleanVal}</span>`;
    }
    return '';
  });

  const stickerRegex = /\[([^\[\]]+)\]/g;
  safeStr = safeStr.replace(stickerRegex, (match, inner) => {
    let themeClass = 'sticker-theme-default';
    if (inner.includes('🐸')) themeClass = 'sticker-theme-frog';
    else if (inner.includes('🤡')) themeClass = 'sticker-theme-clown';
    else if (inner.includes('🤯')) themeClass = 'sticker-theme-mindblown';
    else if (inner.includes('🗿')) themeClass = 'sticker-theme-chad';
    else if (inner.includes('🍿')) themeClass = 'sticker-theme-popcorn';
    else if (inner.includes('☕')) themeClass = 'sticker-theme-chill';
    else if (inner.includes('🚀')) themeClass = 'sticker-theme-peak';
    else if (inner.includes('🦉')) themeClass = 'sticker-theme-owl';
    else if (inner.includes('🥑')) themeClass = 'sticker-theme-avocado';
    else if (inner.includes('😭')) themeClass = 'sticker-theme-emotional';
    else if (inner.includes('🔥')) themeClass = 'sticker-theme-fire';
    else if (inner.includes('💤')) themeClass = 'sticker-theme-sleepy';

    return `<span class="inline-sticker-badge ${themeClass}"><span class="sticker-shine"></span>${inner}</span>`;
  });

  if (extractedStickers) {
    extractedStickers = `<div style="display: flex; flex-wrap: wrap; justify-content: flex-start; margin-bottom: 4px;">${extractedStickers}</div>`;
  }

  // Combine extracted stickers with the rest of the text
  let trimmedStr = safeStr.trim();
  let textHtml = trimmedStr ? `<div style="text-align: left; word-break: break-word;">${trimmedStr}</div>` : '';
  
  let finalHtml = extractedStickers + textHtml;
  // If there are multiple trailing <br>, clean them up
  finalHtml = finalHtml.replace(/^(<br>)+|(<br>)+$/g, '');
  
  return finalHtml;
}
